<template>
<el-drawer :title="drawer.title" :visible.sync="drawer.visible" size="30%">
    <div class="drawer-form">
        <el-form :model="ruleForm" :rules="rules" ref="contractnomRuleForm" labelPosition="top" class="ruleForm" v-loading="loading">
            <el-form-item label="选择公司" prop="collection_code">
                <el-select v-model="ruleForm.company_id" clearable filterable class="select with100" placeholder="选择公司">
                    <el-option v-for="item in companyList" :key="item.id" :label="item.title" :value="item.id+ ''"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item v-if="type=='add'" label="收款号列表" prop="collection_code">
                <el-input type="textarea" v-model="ruleForm.collection_code"></el-input>
            </el-form-item>
           <el-form-item v-if="type=='edit'" label="收款号" prop="collection_code">
                <el-input type="input" v-model="ruleForm.collection_code"></el-input>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="submitForm('contractnomRuleForm')">保存</el-button>
                <el-button @click="resetForm('contractnomRuleForm')">重置</el-button>
            </el-form-item>
        </el-form>
    </div>
</el-drawer>
</template>

<style lang="less">
@import url('@/assets/css/drawer.less');

.ruleForm {
    padding: 0 32px;
}
</style>

<script>
import dictionary from '@/utils/dictionary'
const ruleForm = {
    id: 0,
    company_id: '',
    collection_code: ''
}
export default {
    data() {
        return {
            ruleForm: Object.assign({}, ruleForm),
            drawer: {
                title: '',
                visible: false
            },

            rules: {
                collection_code: [{
                    required: true,
                    message: '请输入订单号',
                    trigger: 'blur'
                }]
            },
            loading: false,
            type: ""
        };
    },
    beforeMount() {
        this.dictionary = dictionary;
    },
    computed: {
        companyList: function () {
            return dictionary.getPicker('company');
        },

    },
    methods: {
        showDrawer(options, type) {
            let _this = this;
            _this.type = type;
            if (options == '') {
                _this.drawer.title = '添加订单号';
            } else {
                _this.ruleForm.id=options.id
                _this.drawer.title = '编辑订单号';
            }
            _this.drawer.visible = true;
            if (options != '') {
                let url = '/api/order.collection_code/read';
                let query = {
                    id:options.id
                };
                this.$post(url, query).then(function (response) {
                        _this.ruleForm.company_id=response.data.row.company_id+'';
                        _this.ruleForm.collection_code=response.data.row.collection_code
                });
            } else {
                _this.resetForm('contractnomRuleForm');
            }
        },
        submitForm(formName) {
            this.loading = true;
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    let that = this;
                    let url = '';
                    if (this.ruleForm.id == '') {
                        url = '/api/order.collection_code/create';
                    } else {
                        url = '/api/order.collection_code/save';
                    }

                    this.$post(url, this.ruleForm).then(function (response) {
                        if (response.code == '200') {
                            that.drawer.visible = false;
                            that.resetForm(formName);
                            that.$emit('getTableData');

                            that.$message({
                                message: response.msg,
                                type: 'success'
                            });
                            // that.$emit('showLog', response.data.failList);
                            that.loading = false;
                        } else {
                            that.$message(response.msg);
                        }
                    });
                } else {
                    return false;
                }
            });
        },
        resetForm(formName) {
            this.ruleForm = Object.assign({}, ruleForm)
            if (this.$refs[formName] !== undefined) {
                this.$refs[formName].resetFields();
            }
        }
    }
};
</script>
